export enum MenuVariant {
    permanent = 'permanent',
    temporary = 'temporary',
    persistent = 'persistent',
}
